import { render, staticRenderFns } from "./EditOfferDetails.vue?vue&type=template&id=5128e671"
import script from "./EditOfferDetails.vue?vue&type=script&lang=ts"
export * from "./EditOfferDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports